import React from 'react';
import { List, ListItem, Box, ListItemAvatar, Avatar, ListItemSecondaryAction} from '@material-ui/core';
import {SortableContainer, SortableElement} from 'react-sortable-hoc';
import arrayMove from 'array-move';

const itemStyle = {marginTop: "8px", backgroundColor: "#2aaede05" }

export const UnsortableList = ({devMode, details, rows, columns, addItem, data}) => {

  return (
    <Box style={devMode ? {width: "100%", backgroundColor: "#2a2b27"} : { width: "100%"}}>
      <Container addItem={addItem} details={details}> 
        {rows && rows.map((item, index) => (
          <Item devMode={devMode} key={item.id} {...{index, item, columns, data, details}} />
        ))}
      </Container>
    </Box>
  );
}


const Container = ({children, addItem, details}) => {
  return (
    <List> 
      {children}
      {addItem && !details && <ListItem style={{...itemStyle, border: "1px #2aaede dashed"}}>{addItem}</ListItem>}
    </List>
  );
}

const Item = ({devMode, index, item, columns, data, details}) => {
  const primaryText = columns
    .filter(x => x.field !== "acciones")
    .map(c => c.renderCell ? c.renderCell({row: item, extraData: data}) : ( item ? item[c.field] : "" ) )
    .filter(x => x !== ""); 
  return (
    <div key={item.id} style={{zIndex: 100000}}>
      <ListItem style={{...itemStyle, border: "1px #2aaede solid", backgroundColor: devMode ? "#5d5d5d" : "white", opacity: 1, color: devMode ? "white" : "rgba(0, 0, 0, 0.87)"}}>
        <ListItemAvatar>
          <Avatar style={{width: 30, height: 30}}>
            {index + 1}
          </Avatar>
        </ListItemAvatar>
        {primaryText.map((x, index) => index < (primaryText.length-1) ? <div key={index}>{x}<span style={{paddingRight: 6}}>, </span></div> : <div key={index}><span>{x}</span></div> )}
        {!details && 
          <ListItemSecondaryAction>
            {columns.some(x => x.field === "acciones") && columns.filter(x => x.field === "acciones")[0].renderCell({row: item})}
          </ListItemSecondaryAction>
        }
      </ListItem>
    </div>

  )
}